import script from "./HomeBanner.vue?vue&type=script&setup=true&lang=ts"
export * from "./HomeBanner.vue?vue&type=script&setup=true&lang=ts"

import "./HomeBanner.vue?vue&type=style&index=0&id=81fe12e8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-81fe12e8"]])

export default __exports__